module.exports = __webpack_public_path__ + "static/SM_CaseIT-2022_FR-a586d51c4b378400405ebecf988a9792.pdf";